import type {CategoryModel} from '../../../domain/Category/Category.model';

export abstract class FetchCategoriesQuery {
  abstract fetch(
    params?: FetchCategoriesQuery.Params,
  ): Promise<FetchCategoriesQuery.Response>;
}

export namespace FetchCategoriesQuery {
  export type Params = {
    type: CategoryModel.Type;
  };

  export type Response = CategoryModel[];
}
